module.exports = __webpack_public_path__ + "static/silver-d17f50f72b563cd190cfd2ec88f0accb.png";